import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import ActionLink from '../../../components/ActionLink';
import AppPrefixUtils from '../../../utils/AppPrefixUtils';
import AuthService from '../../../services/AuthService';
import CriteriaTextComponent from '../../../components/criteria/CriteriaTextComponent';
import BaseListContainer from '../../../baseContainers/BaseListContainer';
import VoucherCategoryService from '../../../services/VoucherCategoryService';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class VoucherCategoryListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new VoucherCategoryService());
        this.state = {
            list: [],
            loading: true,
            criteria: this.getCleanSearchCriteria(),
        };
        this.authService = new AuthService();
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.name,
            locale: criteria.locale,
            date_from: criteria.dataFrom,
            date_to: criteria.dataTo,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            name: '',
            locale: this.authService.getI18n(),
            date_from: undefined,
            date_to: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'voucherCategory.listTitle';
    }
    getCriteriaName() {
        return 'voucher-category-list-sc';
    }

    getContainerListName() {
        return 'voucher-category-list-container';
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    label={t('voucherCategory.name')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
            </div>
        );
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.authService.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('voucherCategory.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {
                field: 'id',
                header: t('ID'),
                sortable: true,
            },
            {
                field: 'name',
                header: t('voucherCategory.name'),
                sortable: true,
            },
            {
                key: 'actions',
                header: t('global.action'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    actionTemplate(rowData) {
        const menuRef = React.createRef();
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(detailHref),
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }
    //override
    actionTemplate2(rowData) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/`+sessionStorage.getItem('i18nextLng');
        return (
            <div>
                <ActionLink
                    rendered={this.backLinkRendered}
                    className='p-link float-right'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    iconName='mdi-pen'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
                <span></span>
            </div>
        );
    }

    breadCrumbItems() {
        return [{name: t('voucherCategory.listTitle'), url: '/voucher-category-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

VoucherCategoryListContainer.defaultProps = {
    detailUrl: '/voucher-category/details',
    newUrl: '/voucher-category/create',
    editUrl: '/voucher-category/edit',
    lazy: true,
};

VoucherCategoryListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(VoucherCategoryListContainer));
